import React from 'react';
import { Link } from 'react-router-dom';
import { Search, ArrowRight } from 'lucide-react';

/**
 * Calm empty state for marketplace list pages.
 */
const MarketingBrowseEmpty = ({
  title = 'Nothing matched',
  description = 'Try adjusting your search or filters.',
  onClear,
  clearLabel = 'Clear filters',
  secondaryHref = '/browse-vendors',
  secondaryLabel = 'Browse all vendors',
}) => {
  return (
    <div className="py-20 text-center">
      <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full border border-m-border-light bg-m-surface">
        <Search className="h-7 w-7 text-m-ink-muted" />
      </div>
      <h3 className="mb-2 text-lg font-medium tracking-tight text-m-ink">{title}</h3>
      <p className="marketing-body mx-auto mb-7 max-w-md text-m-ink-muted">
        {description}
      </p>
      <div className="flex flex-col items-center justify-center gap-3 sm:flex-row">
        {onClear ? (
          <button type="button" onClick={onClear} className="marketing-btn marketing-btn-ink">
            {clearLabel}
          </button>
        ) : null}
        <Link
          to={secondaryHref}
          className="inline-flex h-[var(--m-control-h)] items-center justify-center gap-2 rounded-full border border-m-border-light px-6 text-sm font-medium text-m-ink transition-colors hover:border-m-ink"
        >
          {secondaryLabel}
          <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  );
};

export default MarketingBrowseEmpty;
